var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, LoadingButton, TextField, Alert, } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ZIPCODE_REGEX } from '../../constants/regex';
import { StaticField } from '../shared/static-field/static-field';
import { SectionHeader } from '../shared/section-header/section-header';
import { addressesApi } from '../../api/common/addresses';
import { b2bValidationSchema, b2cValidationSchema } from './validation';
import { SUCCESS_MSG } from '../../constants/response-success-messages';
import { ERR_SAVE, ERRORS_CODE, ERR_PHONE, ERR_INVALID_ZIP, } from '../../constants/response-error-messages';
import { ZIPCODE_LENGTH } from '../../constants/general';
import { useProfile } from '../../hooks/use-profile';
import { setEditEvent, pushErrorEvent } from '../../utils/analytics';
import { getTextFieldStatus, mapPersonalFormValuesToRequestModel, } from '../../utils/form';
import { newrelic, setNewRelicQuantumMetricsAttributes, } from '../../utils/newrelic';
export var PersonalInfo = function () {
    var _a, _b, _c;
    var profileValues = useProfile();
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), editMode = _e[0], setEditMode = _e[1];
    var _f = useState(null), successMsg = _f[0], setSuccessMsg = _f[1];
    var _g = useState(null), errorMsg = _g[0], setErrorMsg = _g[1];
    var _h = useState(false), pendingZipCode = _h[0], setPendingZipCode = _h[1];
    var _j = useState(false), isZipCodeError = _j[0], setIsZipCodeError = _j[1];
    var isB2B = profileValues.isB2B, customerData = profileValues.customerData, updatePersonalDetails = profileValues.updatePersonalDetails;
    var isConsumerApp = useContext(ExperienceContext).isConsumerApp;
    var isB2C = !isB2B;
    var defaultValues = {
        firstName: (customerData === null || customerData === void 0 ? void 0 : customerData.firstName) || '',
        lastName: (customerData === null || customerData === void 0 ? void 0 : customerData.lastName) || '',
        zipCode: (customerData === null || customerData === void 0 ? void 0 : customerData.zipCode) || '',
    };
    var _k = useForm({
        resolver: yupResolver(isB2B ? b2bValidationSchema : b2cValidationSchema),
        defaultValues: defaultValues,
        mode: 'onTouched',
    }), register = _k.register, _l = _k.formState, formErrors = _l.errors, isValid = _l.isValid, isDirty = _l.isDirty, handleSubmit = _k.handleSubmit, reset = _k.reset, setValue = _k.setValue;
    useEffect(function () {
        setNewRelicQuantumMetricsAttributes();
        reset(defaultValues);
    }, [customerData]);
    var handleEditMode = function () {
        setEditMode(true);
        setSuccessMsg(null);
    };
    var handleReset = function () {
        setEditMode(false);
        setErrorMsg(null);
        reset(defaultValues);
    };
    var handleOnChangeZipCode = function (event) {
        var newZipCode = event.currentTarget.value;
        setValue('zipCode', newZipCode);
        if (newZipCode === (customerData === null || customerData === void 0 ? void 0 : customerData.zipCode)) {
            setIsZipCodeError(false);
            setErrorMsg(null);
        }
        if (newZipCode !== (customerData === null || customerData === void 0 ? void 0 : customerData.zipCode) &&
            newZipCode.length === ZIPCODE_LENGTH &&
            newZipCode.match(ZIPCODE_REGEX)) {
            setErrorMsg(null);
            setPendingZipCode(true);
            addressesApi
                .getPostalList(newZipCode)
                .then(function () {
                setIsZipCodeError(false);
            })
                .catch(function (errorCode) {
                setErrorMsg(ERR_INVALID_ZIP);
                setIsZipCodeError(true);
                pushErrorEvent('personal info: zip code', 'inline', errorCode || 'n/a', ERR_INVALID_ZIP.message);
            })
                .finally(function () {
                setPendingZipCode(false);
            });
        }
    };
    var trackEditedFields = function (values) {
        var _a;
        if (values.firstName !== defaultValues.firstName) {
            setEditEvent('profile page: edit: personal details', 'first name');
        }
        if (values.lastName !== defaultValues.lastName) {
            setEditEvent('profile page: edit: personal details', 'last name');
        }
        if (values.zipCode !== defaultValues.zipCode) {
            setEditEvent('profile page: edit: personal details', 'zipcode');
        }
        if (isConsumerApp) {
            (_a = window === null || window === void 0 ? void 0 : window.LIFE_CYCLE_EVENT_BUS) === null || _a === void 0 ? void 0 : _a.trigger('NATIVE_APP.PROFILE_NAME', {
                firstName: values === null || values === void 0 ? void 0 : values.firstName,
                lastName: values === null || values === void 0 ? void 0 : values.lastName,
            });
        }
        if (isB2C)
            newrelic.addPageAction('zipCode-from-editProfile', {
                zipcode: values.zipCode,
            });
    };
    var onSubmitPersonalInfo = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var isInvalidForm, requestData;
        return __generator(this, function (_a) {
            if (!isDirty) {
                handleReset();
                return [2 /*return*/];
            }
            isInvalidForm = !isValid || pendingZipCode || isZipCodeError;
            if (!isInvalidForm) {
                setLoading(true);
                setSuccessMsg(null);
                setErrorMsg(null);
                requestData = mapPersonalFormValuesToRequestModel(values, 
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                customerData);
                updatePersonalDetails(requestData)
                    .then(function () {
                    setSuccessMsg(SUCCESS_MSG);
                    setEditMode(false);
                    trackEditedFields(values);
                    newrelic.addPageAction('update-profile-success', {
                        result: 'success',
                    });
                })
                    .catch(function (errorCode) {
                    if (errorCode === ERRORS_CODE.ERR_PHONE) {
                        setErrorMsg(ERR_PHONE);
                        pushErrorEvent('personal info', 'inline', errorCode || 'n/a', ERR_PHONE.message);
                    }
                    else {
                        setErrorMsg(ERR_SAVE);
                        pushErrorEvent('personal info', 'inline', errorCode || 'n/a', ERR_SAVE.message);
                    }
                    newrelic.addPageAction('update-profile-failure', {
                        result: errorCode,
                    });
                })
                    .finally(function () {
                    setLoading(false);
                });
            }
            return [2 /*return*/];
        });
    }); };
    return (React.createElement("div", null,
        React.createElement(SectionHeader, { title: "PERSONAL DETAILS", actionLabel: editMode ? 'Cancel' : 'Edit', onActionClick: editMode ? handleReset : handleEditMode, dataTestIdBtn: editMode ? 'personaInfoHeaderCancelBtn' : 'personalInfoHeaderEditBtn' }),
        successMsg && (React.createElement("div", { className: "sui-mb-8" },
            React.createElement(Alert, { status: "success", onClose: function () { return setSuccessMsg(null); } }, successMsg.message))),
        React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-4 sm:sui-gap-0" },
            !editMode && (React.createElement(React.Fragment, null,
                React.createElement(StaticField, { title: "First Name", content: (customerData === null || customerData === void 0 ? void 0 : customerData.firstName) || '', dataTestIdTitle: "personalDetailsFistNameLabel", dataTestIdContent: "personalDetailsFirstNameValue", "data-qm-mask": "" }),
                React.createElement(StaticField, { title: "Last Name", content: (customerData === null || customerData === void 0 ? void 0 : customerData.lastName) || '', dataTestIdTitle: "personalDetailsLastNameLabel", dataTestIdContent: "personalDetailsLastNameValue", "data-qm-mask": "" }),
                isB2C && (React.createElement(StaticField, { title: "ZIP Code", content: (customerData === null || customerData === void 0 ? void 0 : customerData.zipCode) || '', dataTestIdTitle: "personalDetailsZipCodeLabel", dataTestIdContent: "personalDetailsZipCodeValue", "data-qm-mask": "" })))),
            editMode && (React.createElement("div", { className: "sui-grid sui-grid-cols-6" },
                React.createElement("div", { className: "sui-col-span-6 lg:sui-col-span-5" },
                    React.createElement("form", { className: "sui-grid sui-gap-y-5 lg:sui-gap-y-8", onSubmit: handleSubmit(onSubmitPersonalInfo) },
                        React.createElement("div", null,
                            React.createElement(TextField, { fullWidth: true, label: "First Name", id: "firstName", placeholder: "First Name", status: getTextFieldStatus(formErrors.firstName), statusMessage: (_a = formErrors.firstName) === null || _a === void 0 ? void 0 : _a.message, InputProps: __assign(__assign({}, register('firstName')), { inputProps: {
                                        'data-qm-mask': '',
                                        'data-testid': 'personal-info-first-name-inpt',
                                    } }) })),
                        React.createElement("div", null,
                            React.createElement(TextField, { fullWidth: true, label: "Last Name", placeholder: "Last Name", id: "lastName", status: getTextFieldStatus(formErrors.lastName), statusMessage: (_b = formErrors.lastName) === null || _b === void 0 ? void 0 : _b.message, InputProps: __assign(__assign({}, register('lastName')), { inputProps: {
                                        'data-qm-mask': '',
                                        'data-testid': 'personal-info-last-name-inpt',
                                    } }) })),
                        isB2C && (React.createElement("div", null,
                            React.createElement(TextField, { fullWidth: true, label: "ZIP Code", id: "zipCode", placeholder: "ZIP Code", status: getTextFieldStatus(formErrors.zipCode), statusMessage: (_c = formErrors.zipCode) === null || _c === void 0 ? void 0 : _c.message, InputProps: __assign(__assign({}, register('zipCode', {
                                    onChange: handleOnChangeZipCode,
                                })), { inputProps: {
                                        maxLength: ZIPCODE_LENGTH,
                                        'data-qm-mask': '',
                                        'data-testid': 'personal-info-zip-code-inpt',
                                    } }) }))),
                        errorMsg && (React.createElement("div", null,
                            React.createElement(Alert, { status: "error" }, errorMsg.message))),
                        React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-5 sm:sui-grid-cols-2" },
                            React.createElement("div", { className: "sui-order-1 sm:sui-order-2" },
                                React.createElement(LoadingButton, { type: "submit", variant: "primary", loading: loading, fullWidth: true, "data-testid": "personalDetailsSaveBtn" }, "Save Changes")),
                            React.createElement("div", { className: "sui-order-2 sm:sui-order-1" },
                                React.createElement(Button, { type: "button", variant: "secondary", fullWidth: true, onClick: handleReset, "data-testid": "personalDetailsCancelBtn" }, "Cancel"))))))))));
};
